import { Form } from './form.js';
import { Event } from '../global/event.js';
import { IbanCalculator } from '../global/ibancalculator.js';
import { PayOne } from '../global/payone.js';
import { PaymentOption } from './payment/paymentoption.js';

export class Payment extends Event {
    constructor() {
        super();
        this.options = [];
        this.Payone = new PayOne();
        this.form = document.querySelector('#form-landingpage');
        this.submitButton = document.querySelector('#submitOrder');
        this.fakturaSelect = document.querySelector('#payment-faktura');
        this.paymentHolder = document.querySelector('#holder-payment');
        this.inputPrice = document.querySelector('input[name="order[product_price]"]');
        this.inputSurcharge = document.querySelector('input[name="order[surcharge]"]');
        this.clearingType = document.querySelector('input[name="payment[clearingType]"]');
        this.deliveryStart = document.querySelector('input[name="order[deliveryStart]"]');
        this.ausgaben = document.querySelector('#ausgaben');
        this._creditcardHolder = document.querySelector('.payform-creditcard');
        this._pseudocardpan = document.querySelector('input[name="payment[pseudocardpan]"]');
        this.iban = document.querySelector('input[name="payment[iban]"]');
        this.paypalexpress = document.querySelector('.ce.paypal');
        
        this.price = {
            offer : [],
            device: false,
            surcharge: {
                bonus : 0,
                addon : 0,
            },
            upsell : false,
        };
        this.isFree = false;
        this.editionsRequest = new Request('POST', this.form.getAttribute('action') + '/editions');
        
        this.init();
    };

    get selectedOption() {
        let opt;
        this.options.every(option => {
            if (option.isSelected) {
                opt = option;
                return false;
            }
            return true;
        });
        return opt;
    }

    get paymentType() {
        return (this.isFree) ? 'free' : 'paid';
    }
    
    get isValidated() {
        return this.Payone.validated;
    }
    
    get surcharge() {
        let value = parseFloat(0);
        if(this.price.surcharge) {
            value += parseFloat(this.price.surcharge.bonus);
            value += parseFloat(this.price.surcharge.addon);
        }
        return value;
    }

    get isPaypalExpress() {
        let element = document.querySelector('.payform-paypal');
        return element.dataset.express;
    }

    set offerPrice(offer) {
        if(offer && typeof offer !== "object") {
            offer = [{title : 'Abo', value : parseFloat(offer)}];
        }

        this.price.offer = [];

        offer.forEach((data, index) => {
            if(typeof this.price.offer[index] !== 'undefined') {
                this.price.offer[index].value = data.value;
            } else {
                this.price.offer.push(data);
            }
        });
        this.update();
    }

    set devicePrice(value) {
        if(typeof value !== 'boolean' && typeof value !== 'undefined') {
            this.price.device = parseFloat(value);
        }
        this.update();
    }

    set upsellPrice(value) {
        this.price.upsell = value;
        this.update();
    }

    init() {
        this.watchInputs();
        this.checkFreeOrder();
        
        this.Payone.success = (response => {
            if(response.status == 'ok') {
                this._pseudocardpan.value = response.pseudocardpan;
                this.fireEvent('submitLandingpage');
            }
        });

        let ibanCalculator = new IbanCalculator('#payment-accountnumber', '#payment-bankcode');

        ibanCalculator.addEventListener('updateIban', event => {
            this.iban.setAttribute('placeholder', event.detail.placeholder);
            this.iban.value = event.detail.value;
        });
    };

    update() {
        if(this.isFree) {
            this.price.offer[0]['value'] = 0;
        }
        this.inputSurcharge.value = this.surcharge;
        this.fireEvent('updatePrice', this.price);
    }
    
    watchInputs() {
        if (this.iban) {
            this.iban.addEventListener('input', () => {
                this.iban.value = OVS.app.helper.formatIBAN(this.iban.value);
            });
        }

        this.fakturaSelect.addEventListener('change', () => {
            let element = this.fakturaSelect.options[this.fakturaSelect.selectedIndex];
            this.fireEvent('updateFaktura', element.dataset.rabat);
        });
        
        let payoptions = document.querySelectorAll('.payoption');
        if(payoptions) {
            payoptions.forEach(element => {
                let option = new PaymentOption(element);

                option.addEventListener('select', event => {
                    this.clearingType.value = event.detail.type;
                    this.fireEvent('updatePayment', {
                        title: event.detail.title,
                        type: event.detail.type,
                    });
                    this.fireEvent('updatePosition');
                    this.checkFreeOrder();
                });

                this.options.push(option);
            });
        }
    }

    resetOffer() {
        this.price.offer = false;
        this.price.upsell = false;
    }

    resetBonus() {
        this.price.device = false;
        this.price.surcharge.bonus = 0;
    }

    resetAddon() {
        this.price.surcharge.addon = 0;
    }

    getOptionByValue(value) {
        let opt;
        this.options.every(option => {
            if (option.type == value) {
                opt = option;
                return false;
            }
            return true;
        });
        return opt;
    }
    
    updatePaymentOptions(newOptions = false) {
        if (this.isPaypalExpress) {
            newOptions = ['paypal'];
        }

        this.options.forEach(option => {
            if (Array.from(newOptions).includes(option.type)) {
                option.show();
            } else {
                option.hide();
            }
        });
        
        this.updatePaymentOptionLayout();
    };
    
    selectFirstPayment() {
        this.options.every(option => {
            if (option.isVisible) {
                option.select();
                return false;
            }
            return true;
        });
    };

    updatePaymentOptionLayout() {
        let _options = [];
        this.options.forEach(option => {
            option.isFirst = false;
            option.isLast = false;
            if (option.isVisible) {
                _options.push(option);
            }
        });

        if (_options.length) {
            _options[0].isFirst = true;
            _options[_options.length-1].isLast = true;
        }
    };
    
    faktura(ids) {
        let opts = [];
        let fallback = '';
        if(!ids) {
            this.fakturaSelect.innerHTML = fallback;
            return false;
        }
        
        Array.from(this.fakturaSelect.options).forEach(option => {
            let id = option.dataset.id;
            
            if(id == 'month') {
                fallback = option;
            }
            
            if(!ids.includes(id)) {
                opts.push(option);
            }
        });
        
        opts.forEach(o => {
            o.remove();
        });
        
        if(this.fakturaSelect.options.length < 1) {
            this.fakturaSelect.add(fallback);
        }
        
        OVS.app.helper.singleSelect(this.fakturaSelect);
    };
    
    getPrice(offerId, bonusId = 0, variantId = 0, touched = false) {
        let form = new Form();
        
        if(form.isReady) {
            let data = {
                offerId: offerId,
                bonusId: bonusId,
                bonusVariantId: variantId,
                street: form.street,
                housenumber: form.housenumber,
                postcode: form.postcode,
                city: form.city,
                country: form.country,
                deliverystart: this.deliveryStart.value
            };

            if (touched && this.ausgaben && this.ausgaben.value != '') {
                data.pva = this.ausgaben.value;
            }

            this.editionsRequest.data = data;
            
            this.fireEvent('priceLoader');
            this.editionsRequest.call(data => {
                if(data.status == 'ok') {
                    if(data.address) {
                        form.street = data.address.street;
                        form.housenumber = data.address.housenumber;
                        form.postcode = data.address.postcode;
                        form.city = data.address.city;
                    }

                    if (data.price.offer) {
                        this.offerPrice = data.price.offer;
                    }

                    if (data.price.device) {
                        this.devicePrice = data.price.device;
                    }
                    this.checkFreeOrder();
                    this.fireEvent('removeLoader');
                    this.fireEvent('updateAusgabe', data.editions);
                    this.fireEvent('updateDeliveryDate', data.deliveryStart);
                } else {
                    this.fireEvent('removeLoader');
                    this.fireEvent('addressError', form.getElementName(data.field));
                }
            });
        }
    };
    
    checkFreeOrder() {
        let submitText = 'Jetzt kostenpflichtig bestellen';
        let offers = 0;
        
        if(this.price.offer) {
            this.price.offer.forEach(price => {
                offers += parseFloat(price.value);
            });
        }
        
        if(this.isFree || (!offers && !this.price.device && !this.surcharge) ) {
            submitText = 'Jetzt kostenlos bestellen';
            this.paymentHolder.classList.add('d-none');
            this.fakturaSelect.classList.add('d-none');
            this.fireEvent('updatePayment', {
                title: 'kostenlos',
            });
            this.clearingType.value = 'free';

            if (this.paypalexpress) {
                this.paypalexpress.classList.add('d-none');
            }
        } else {
            this.paymentHolder.classList.remove('d-none');
            if (this.selectedOption.type != 'current') {
                this.fakturaSelect.classList.remove('d-none');
            }
            this.clearingType.value = this.selectedOption.type;
            if (this.paypalexpress) {
                this.paypalexpress.classList.remove('d-none');
            }
        }
        
        this.submitButton.innerHTML = submitText;
        this.submitButton.setAttribute('data-original-text', submitText);
    };
    
    initCreditCard() {
        this.Payone.initCreditCard((response) => {
            if(response.status == "ok") {
                let spinner = this._creditcardHolder.querySelector('.spinner');
                let loadholder = this._creditcardHolder.querySelector('.load-holder');
                
                if(spinner) {
                    spinner.classList.add('d-none');
                }
                if(loadholder) {
                    loadholder.classList.remove('d-none');
                }
            } else {
                this.disable('creditcard');
            }
        });
    };
    
    updateReportingPrice() {
        let price = '';

        let summaryOfferTitles = document.querySelectorAll('.summary-offer-title');
        let summaryOfferPrices = document.querySelectorAll('.summary-offer-price');
        
        for(let i = 0; i < summaryOfferPrices.length; i++) {
            price += summaryOfferTitles[i].innerHTML + ' ' + OVS.app.helper.humanPrice(summaryOfferPrices[i].innerHTML) + ' €';
            price += '\n';
        }

        if(this.price.device) {
            price += '\n+ Gerät monatlich ' + OVS.app.helper.humanPrice(this.price.device) + ' €';
        }

        if(this.price.upsell) {
            price += '\n+ ' + this.price.upsell.title + ' ' + OVS.app.helper.humanPrice(this.price.upsell.value) + ' €';
        }

        this.inputPrice.value = price.trim();
    };
};
